const C = {
  name: "Browser",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 7C8.25 7.69036 7.69036 8.25 7 8.25C6.30964 8.25 5.75 7.69036 5.75 7C5.75 6.30964 6.30964 5.75 7 5.75C7.69036 5.75 8.25 6.30964 8.25 7Z" fill="currentColor"/>
<path d="M11 8.25C11.6904 8.25 12.25 7.69036 12.25 7C12.25 6.30964 11.6904 5.75 11 5.75C10.3096 5.75 9.75 6.30964 9.75 7C9.75 7.69036 10.3096 8.25 11 8.25Z" fill="currentColor"/>
<path d="M16.25 7C16.25 7.69036 15.6904 8.25 15 8.25C14.3096 8.25 13.75 7.69036 13.75 7C13.75 6.30964 14.3096 5.75 15 5.75C15.6904 5.75 16.25 6.30964 16.25 7Z" fill="currentColor"/>
<path d="M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V5Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Browser
};
